import {MatPaginatorIntl} from '@angular/material/paginator';
import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({providedIn: 'root'})
export class CdkMatPaginatorIntl extends MatPaginatorIntl {
    changes = new Subject<void>();
    firstPageLabel = 'Primeiro';
    itemsPerPageLabel = ''; // ALTERADO PELA PGE-RS: deixado em branco.
    nextPageLabel = 'Seguinte';
    previousPageLabel = 'Anterior';
    lastPageLabel = 'Último';

    // ALTERADO PELA PGE-RS: para mostrar a qtde de registros totais da grid.
    getRangeLabel = (page: number, pageSize: number, length: number) => {
        if (length === 0) {
            return `Nenhum registro`;
        }
        if (length === 1) {
            return `Pág. 1 (1 registro)`;
        }

        // Garante que o número da página é válido
        const totalPages = Math.ceil(length / pageSize);
        const validPage = Math.min(page, totalPages - 1);

        const startIndex = validPage * pageSize;

        const endIndex = Math.min(startIndex + pageSize, length);

        if (totalPages == 1) {
            return `Pág. 1 (${length} registros)`;
        }
        return `Pág. ${validPage + 1} de ${totalPages} (${length} registros)`;
    }
}
